import React from "react";
import { useHotel } from "@/hooks/useHotel";
import { useTranslation } from "react-i18next";
import { useGetPartnerSettings } from "./hooks/partner-settings.hooks";
import { BillingPageState } from "../billing-settings/components/BillingPageState";
import { PartnerSettingsCard } from "./components/PartnerSettingsCard";
import { PartnerSectionForm } from "./components/PartnerSectionForm";

// Task 0036, contract 2026-09-29: sync status/logs and their export moved
// off this page entirely (the hotel-scoped `/partners/sync(/status)` and
// `/partners/logs` endpoints now 404 — see `adminPartnersService` for the
// Guesteria-admin-only replacements, on a dedicated admin sync page).
export const PartnerIntegrationSettingsPage = (): React.JSX.Element => {
  const { hotelId } = useHotel();
  const { t } = useTranslation();

  const { data: partnerSettings, isLoading, isError } = useGetPartnerSettings();

  if (!hotelId) {
    return <BillingPageState text={t("partners.hotelNotSelected")} />;
  }

  if (isLoading) {
    return <BillingPageState text={t("partners.loading")} />;
  }

  if (isError) {
    return <BillingPageState text={t("partners.loadingError")} tone="error" />;
  }

  if (!partnerSettings) {
    return <BillingPageState text={t("partners.noPartners")} />;
  }

  return (
    <div className="flex max-w-6xl flex-col gap-6 p-6 md:p-12">
      <PartnerSettingsCard>
        <PartnerSectionForm settings={partnerSettings} />
      </PartnerSettingsCard>
    </div>
  );
};
